var _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberZee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "23.74 31.25 39.26 31.25 39.26 30.76 24.25 30.76 24.25 16.75 8.75 16.75 8.75 17.26 23.74 17.26 23.74 31.25",
    fill: "silver",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberZee);
export default __webpack_public_path__ + "static/media/IconMemberZee.d50c60bcc3b7dbe62903353cf0b318e3.svg";
export { ForwardRef as ReactComponent };